import { combineEpics } from "redux-observable";

import getMonitoringQueueEntriesEpic$ from "./getMonitoringQueueEntriesEpic";
import getMonitoringQueueEntriesCountEpic$ from "./getMonitoringQueueEntriesCountEpic";
import getMonitoringQueueEntryDetailsEpic$ from "./getMonitoringQueueEntryDetailsEpic";
import updateClientScoringResultStatusEpic$ from "./updateClientScoringResultStatusEpic";
import createWatchListIgnoringPropertyEpic$ from "./createWatchListIgnoringPropertyEpic";
import createNegativeMediaIgnoringPropertyEpic$ from "./createNegativeMediaIgnoringPropertyEpic";
import exportMonitoringQueueEpic$ from "./exportMonitoringQueueEpic";
import getScoreCardRiskFactorsEpic$ from "./getScoreCardRiskFactorsEpic";
import getScoreCardsByTypeEpic$ from "../../../epics/getScoreCardsByTypeEpic";
import getScoringDecisionTemplateEpic$ from "./getScoringDecisionTemplateEpic";

export default combineEpics(
  getMonitoringQueueEntriesEpic$,
  getScoreCardRiskFactorsEpic$,
  getMonitoringQueueEntriesCountEpic$,
  getMonitoringQueueEntryDetailsEpic$,
  updateClientScoringResultStatusEpic$,
  createWatchListIgnoringPropertyEpic$,
  createNegativeMediaIgnoringPropertyEpic$,
  exportMonitoringQueueEpic$,
  getScoreCardsByTypeEpic$,
  getScoringDecisionTemplateEpic$
);



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/epics/index.js